@if (isString(headerKey) || isString(messageKey)) {
  <div class="alert alert-danger" role="group" tabindex="-1">
    @if (isString(headerKey)) {
      <h2>{{ headerKey | translate }}</h2>
    }
    @if (isString(messageKey)) {
      <p>{{ messageKey | translate }}</p>
    }
  </div>
}
